/**
 * The ROLES slice of the Admin surface (custom-roles design §1.6).
 *
 * Named `routes.roles.tsx` for the reason `routes.infra.tsx` records — one route
 * array per work stream, meeting only in `src/routes.extra.ts`, so streams never
 * race for one filename.
 *
 * ⚠ `/countries/:cc/admin/roles`, AND THE `:cc` SCOPES THE CHROME, NOT THE DATA —
 * exactly as `routes.users.tsx` explains for the users screens, and for the same
 * reason: a role carries no `country_id`, the API routes behind these screens carry
 * no `:cc`, and switching country does not change the list. What the `:cc` feeds is
 * the shell (`RequireCountry` + `AppShell`) and the permission check the screens run
 * against the country on display.
 *
 * The screens use inline alerts rather than the inquiries toast, so no provider
 * layout route is needed — the infra slice's precedent.
 */

import type { RouteObject } from 'react-router-dom';
import { RolesListPage } from './RolesListPage';
import { RoleDetailPage } from './RoleDetailPage';

export const adminRolesRoutes: RouteObject[] = [
  { path: 'admin/roles', element: <RolesListPage /> },
  { path: 'admin/roles/:roleId', element: <RoleDetailPage /> },
];
